/* Hello Baby Box — inline-price CTA for variants and simple PDP templates.
   Updates the add-to-cart button label so it reads "Shto në shportë — 25€"
   instead of just "Shto në shportë". Reacts to variant changes.

   Defensive: every public entry point (init, refresh, handlers) is wrapped
   in try/catch so a bad input can't ever bubble a JS error into the cart
   error UI. We don't want to ship cosmetic price updates at the cost of
   surfacing internal errors to customers — silent degradation is fine.
*/
(function () {
  'use strict';

  function safeCall(fn) {
    try {
      return fn();
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[hbb-pdp] suppressed error:', err);
      }
      return undefined;
    }
  }

  function shouldRun() {
    var body = document.body;
    if (!body) return false;
    var cls = body.className || '';
    if (cls.indexOf('template-product') === -1) return false;
    if (document.querySelector('[data-hbb-inline-cta]')) return true;
    if (cls.indexOf('template-suffix-variants') !== -1) return true;
    if (cls.indexOf('template-suffix-simple') !== -1) return true;
    if (cls.indexOf('hbb-inline-cta') !== -1) return true;
    return false;
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    // Prefer the theme's own formatter (handles money_format + locale).
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      try { return window.theme.formatMoney(cents, window.theme.moneyFormat); } catch (e) {}
    }
    // Then Shopify's, but only if money_format is a non-empty string —
    // formatMoney() does a regex match against the format and explodes
    // on undefined in Safari ("The string did not match the expected pattern").
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      typeof window.Shopify.money_format === 'string' &&
      window.Shopify.money_format.length > 0
    ) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) {}
    }
    // Fallback: bare cents → "12,99€" (Albanian-ish format).
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '').replace('.', ',');
    return amount + '€';
  }

  function updateButton(button, priceCents, available) {
    if (!button) return;
    var baseLabel = button.getAttribute('data-hbb-base-label');
    if (!baseLabel) {
      var labelEl = button.querySelector('.btn__label, [data-add-to-cart-text]') || button;
      baseLabel = ((labelEl && labelEl.textContent) || '').trim();
      button.setAttribute('data-hbb-base-label', baseLabel);
    }

    var labelEl = button.querySelector('.btn__label, [data-add-to-cart-text]');
    if (available === false) {
      if (labelEl) labelEl.textContent = baseLabel;
      else button.textContent = baseLabel;
      return;
    }

    var priceText = formatMoney(priceCents);
    var newLabel = priceText ? baseLabel + ' — ' + priceText : baseLabel;
    if (labelEl) labelEl.textContent = newLabel;
    else button.textContent = newLabel;
  }

  function readCurrentVariant() {
    var formInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!formInput) return null;
    var id = formInput.value;
    if (!id || !Array.isArray(window.HBB_PRODUCT_VARIANTS)) return null;
    for (var i = 0; i < window.HBB_PRODUCT_VARIANTS.length; i++) {
      var v = window.HBB_PRODUCT_VARIANTS[i];
      if (v && String(v.id) === String(id)) {
        return v;
      }
    }
    return null;
  }

  function refresh() {
    safeCall(function () {
      var button = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [data-add-to-cart]');
      if (!button) return;
      var variant = readCurrentVariant();
      if (!variant) {
        var fallbackPrice = document.querySelector('[data-product-price] .new-price, [data-product-price]');
        var price = fallbackPrice ? (fallbackPrice.textContent || '').trim() : '';
        var base = button.getAttribute('data-hbb-base-label');
        if (!base) {
          var labelEl = button.querySelector('.btn__label') || button;
          base = ((labelEl && labelEl.textContent) || '').trim();
          button.setAttribute('data-hbb-base-label', base);
        }
        if (price) {
          var labelEl2 = button.querySelector('.btn__label') || button;
          if (labelEl2) labelEl2.textContent = base + ' — ' + price;
        }
        return;
      }
      updateButton(button, variant.price, variant.available);
    });
  }

  function init() {
    safeCall(function () {
      if (!shouldRun()) return;
      refresh();

      document.addEventListener('variant:change', refresh);
      document.addEventListener('product:variant-change', refresh);
      document.addEventListener('change', function (e) {
        if (
          e &&
          e.target &&
          typeof e.target.matches === 'function' &&
          e.target.matches('form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] input[type="radio"], form[action*="/cart/add"] select')
        ) {
          setTimeout(refresh, 50);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
